document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.eight-rox-product').forEach((root) => {
    const galleryMain = root.querySelector('[data-gallery-main]');
    const galleryThumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    if (galleryMain && galleryThumbs.length) {
      let activeIndex = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains('active')));
      const showImage = (index) => {
        activeIndex = (index + galleryThumbs.length) % galleryThumbs.length;
        const active = galleryThumbs[activeIndex];
        galleryMain.src = active.dataset.imageSrc;
        galleryMain.alt = active.dataset.imageAlt || '';
        galleryThumbs.forEach((thumb, thumbIndex) => {
          const selected = thumbIndex === activeIndex;
          thumb.classList.toggle('active', selected);
          thumb.setAttribute('aria-pressed', String(selected));
        });
      };
      galleryThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));
    }
    const variantInput = root.querySelector('[data-variant-input]');
    root.querySelectorAll('.size-choice').forEach((choice) => {
      choice.addEventListener('click', () => {
        root.querySelectorAll('.size-choice').forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-pressed', 'false');
        });
        choice.classList.add('active');
        choice.setAttribute('aria-pressed', 'true');
        if (variantInput) variantInput.value = choice.dataset.variantId;
      });
    });
    root.querySelectorAll('.accordion > button').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.parentElement;
        const open = panel.classList.toggle('open');
        button.setAttribute('aria-expanded', String(open));
      });
    });
    const form = root.querySelector('[data-product-form]');
    const mainSubmit = form?.querySelector('.product-add-main');
    const stickyBar = form?.querySelector('[data-mobile-sticky-product-bar]');
    if (mainSubmit && stickyBar) {
      let stickyFrame;
      const updateStickyBar = () => {
        window.cancelAnimationFrame(stickyFrame);
        stickyFrame = window.requestAnimationFrame(() => {
          stickyBar.classList.toggle('is-visible', mainSubmit.getBoundingClientRect().bottom < 0);
        });
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(updateStickyBar, { threshold: [0, 0.05] });
        observer.observe(mainSubmit);
      }
      window.addEventListener('scroll', updateStickyBar, { passive: true });
      window.addEventListener('resize', updateStickyBar);
      updateStickyBar();
    }
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submits = [...form.querySelectorAll('.product-add')];
      submits.forEach((submit) => { submit.disabled = true; });
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }], sections: 'cart-drawer-section' })
        });
        if (!response.ok) throw new Error('Unable to add product');
        const addResult = await response.json();
        const cart = await fetch('/cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
        const updateEvent = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        updateEvent.action = 'add';
        updateEvent.context = 'product';
        updateEvent.lines = [{ merchandiseId: String(variantInput.value), quantity: 1 }];
        updateEvent.promise = Promise.resolve({ detail: { sections: addResult.sections || {}, cart } });
        document.dispatchEvent(updateEvent);
        document.querySelectorAll('.rox-bag-button').forEach((button) => {
          button.setAttribute('aria-label', `Shopping bag with ${cart.item_count} items`);
        });
        submits.forEach((submit) => { submit.textContent = 'Added to bag'; });
      } catch (error) {
        submits.forEach((submit) => { submit.textContent = 'Try again'; });
      } finally {
        window.setTimeout(() => {
          submits.forEach((submit) => {
            submit.disabled = false;
            submit.innerHTML = 'Add to bag <span aria-hidden="true">→</span>';
          });
        }, 1800);
      }
    });
    root.querySelectorAll('[data-bundle-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          const currentId = Number(variantInput?.value || button.dataset.variantCurrent);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: currentId, quantity: 1 }, { id: Number(button.dataset.variantPair), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Unable to add bundle');
          window.location.href = '/cart';
        } catch (error) {
          button.disabled = false;
          button.textContent = 'Try again';
        }
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-size-chart-modal]');
  if (!modal) return;
  const open = () => { modal.hidden = false; document.body.classList.add('size-chart-open'); };
  const close = () => { modal.hidden = true; document.body.classList.remove('size-chart-open'); };
  document.querySelectorAll('[data-size-guide-open]').forEach((btn) => btn.addEventListener('click', open));
  modal.querySelectorAll('[data-size-guide-close]').forEach((btn) => btn.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
});
